export const ruAboutText = (
  <div className="text1">
    <p>
      <b>
        ProTax Advisors — ваш надежный партнер в области бухгалтерского учета
      </b>
    </p>
    <p>Мы берем на себя цифры, чтобы вы могли развивать свой бизнес.</p>
    <p>
      Добро пожаловать в ProTax Advisors — место, где управление вашими
      финансами становится простым, эффективным и избавляет от стресса. Находясь
      в Лондоне и Бедфордшире, мы специализируемся на помощи стартапам,
      фрилансерам, а также малому и среднему бизнесу в ведении финансовой
      отчетности, позволяя вам сосредоточиться на росте компании.
    </p>
    <p>
      Наша команда полностью квалифицирована и сертифицирована, обладая
      профессиональными аккредитациями в области бухгалтерского учета и
      налогообложения. Мы сочетаем техническую экспертизу с индивидуальным
      подходом, чтобы предоставлять точные и надежные финансовые услуги,
      адаптированные к потребностям вашего бизнеса.
    </p>
    <p>
      ProTax Advisors мы делаем больше, чем просто ведение счетов — мы
      предлагаем четкое руководство и практические советы для процветания вашего
      дела. От бухгалтерского учета, расчета заработной платы и соблюдения
      налоговых требований до бюджетирования, прогнозирования и финансового
      планирования — наши квалифицированные бухгалтеры позаботятся о том, чтобы
      ваши финансы были в порядке, а бизнес был готов к росту.
    </p>
    <p>Сотрудничая с ProTax Advisors, вы получаете:</p>
    <ul>
      <li>
        Квалифицированных и сертифицированных бухгалтеров, которые понимают все
        сложности бизнес-финансов.
      </li>
      <li>
        Персонализированную поддержку, адаптированную к целям и потребностям
        вашей отчетности.
      </li>
      <li>Прозрачные фиксированные цены без скрытых расходов.</li>
      <li>
        Современные цифровые инструменты для эффективного доступа к вашим
        финансовым данным в режиме реального времени.
      </li>
      <li>
        Полное управление учетом и отчетностью, чтобы вы могли сосредоточиться
        на развитии своего бизнеса.
      </li>
    </ul>
  </div>
);
